module.exports = __webpack_public_path__ + "static/media/contact.a18bfd30.svg";